declare namespace $ {

	export class $mol_icon_shuffle extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=shuffle.view.tree.d.ts.map